document.querySelectorAll("button.next").forEach(button => {
  button.addEventListener("click", function () {
    const step = parseInt(this.dataset.step);
    if(step == 1){
      let filledAllFields = false;
      document.querySelectorAll(".form-items.lets-get-started .form-item-input input").forEach((item) => {
        if (!item.value) {
          const name = item.getAttribute('name'); // Corrected method: getAttribute
          if (name !== 'vin') { // Fixed comparison operator
            item.classList.add("error");
            filledAllFields = true; // Fixed variable name typo
          } else {
            const hasVinChecked = item.closest('.form-item-input').querySelector('label.dont-vin input:checked');
            if (!hasVinChecked) {
              item.classList.add("error");
              filledAllFields = true; // Fixed variable name typo
            }
          }
        }
      });

  
      if (filledAllFields) {
        alert("Please fix the errors shown in red on step 1 before continuing.");
        return true;
      }
    }
    else if(step == 2){
      let filledAllFiled2 = false;
      document.querySelectorAll(".wnmb-wrapper textarea[required]").forEach((item) => {
        if (!item.value) {
          item.classList.add("error");
          filledAllFiled2 = true;
        }
      });
      if (filledAllFiled2) {
          alert("Please fix the errors shown in red on step 2 before continuing.");
          return true;
        }
    }

    console.log('step ',step);

    updateSetp(step+1);
  });
});

document.querySelectorAll(".form-items.lets-get-started .form-item-input input").forEach((item) => {
  item.addEventListener("keyup", function () {
    document.querySelectorAll(".form-items.lets-get-started .form-item-input input.error")
      .forEach((input) => {
        input.classList.remove("error");
      });
  });
});

document.querySelectorAll(".wnmb-wrapper textarea").forEach((item) => {
  item.addEventListener("keyup", function () {
    document.querySelectorAll(".wnmb-wrapper textarea[required].error")
      .forEach((textarea) => {
        textarea.classList.remove("error");
      });
  });
});

document.querySelectorAll("button.back").forEach(button => {
  button.addEventListener("click", function () {
    const step = parseInt(this.dataset.step);
    updateSetp(step);
  });
});


/* on payment methood change */
document.querySelectorAll('.stp-payment-box .form-items label.form-item input').forEach(item => {
   item.addEventListener('change', function(){
       document.querySelector('.stp-payment-box .form-items label.form-item.active').classList.remove('active');
       this.closest('label.form-item').classList.add('active');
       const correctPaymentmethod = this.value;
       if(correctPaymentmethod == 'Bill through Reseller'){
         document.querySelector('.bill-throght-reseller').classList.add('show');
       }else{
         document.querySelector('.bill-throght-reseller').classList.remove('show');
       }
     
       if(correctPaymentmethod == 'Pay with Capricorn'){
         document.querySelector('.pay-with-capricorn')?.classList.add('show');
       }else{
         document.querySelector('.pay-with-capricorn')?.classList.remove('show');
       }

       const spbError = document.querySelector('.stp-psm-btr-error');
      if (spbError) {spbError.style.display = 'none';}
   }) 
});

/* nearest resellers search */
document.querySelector('.rsb-search-box input').addEventListener('keyup', function(){
   const searchquery = this.value.toLowerCase();
   // console.log('searchquery ',searchquery);
  document.querySelector('.reseller-list-popup').classList.remove('error');
   if(searchquery.length > 3){
     const filejson = window.excel.fileJson;
     const searchArray = filejson.filter(item => item.Title.toLowerCase().includes(searchquery) || item.Postcode == searchquery || item.Address.toLowerCase().includes(searchquery) || item.Phone == searchquery || item.Country.toLowerCase().includes(searchquery) || item.State.toLowerCase().includes(searchquery));
     // console.log('searchArray ',searchArray);
     let locationListHTMl = '';
     searchArray.forEach((result,index) => {
         const locationHtml = `<div class="ssr-list-wrap">
            <div class="ssr-location">
              <div class="ssr-location-name">${result.Title}</div>
              <div class="ssr-location-address">${result.Address}<br>${result.Suburb +' '+ result.State}<br/>PH: ${result.Phone}</div>
            </div>
            <div class="ssr-set-btn" onClick="setNearestReseller(this,'${searchquery}',${index});"><button type="button">Set Nearset Reseller</button></div>
         </div>`;
         locationListHTMl += locationHtml;
     });
     const resultHtml = locationListHTMl == '' ? `<div class="ssr-location-wrapper"><div class="not-fount">Location not found.</div></div>`:`<div class="ssr-location-wrapper"><div class="ssr-title">These are your ${searchArray.length} closest resellers
</div><div class="ssr-location-grid">${locationListHTMl}</div></div>`;

     document.querySelector('.reseller-search-result').innerHTML = resultHtml;
   }
});

/* scroll to selcted reseller */
document.querySelector('span.selected-reseller-lication').addEventListener('click', function(){
     document.querySelector('.reseller-list-popup').scrollIntoView({ behavior: 'smooth' });
});
/* on preffred shipping methid changes */
document.querySelectorAll('.preferred-shipping-method input').forEach(input => {
    input.addEventListener('change', function(){
        document.querySelector('.preferred-shipping-method').classList.remove('error');
        const psMethod = this.value;
        if(psMethod == 'Other'){
          document.querySelector('.form-items.psm-items').innerHTML = '<label class="form-item"><input type="text" name="preferred_shipping_method" value="" onkeyup="psOther();" placeholder="Please specify"></label>'
        }else{
          document.querySelector('.form-items.psm-items').innerHTML = '';
        }
        // if(psMethod == 'Send directly to me'){
        //   document.querySelector('.checkout-price-table').classList.remove('no-postage-fee')
        // }else{
        //   document.querySelector('.checkout-price-table').classList.add('no-postage-fee')
        // }
        if(psMethod == 'Send to my nominated Reseller'){
          document.querySelector('.stp-payment-box')?.classList.add('send-to-reseller-shipping');
          document.querySelector('.bill-through-reseller input').click();
        }else{
          document.querySelector('.stp-payment-box')?.classList.remove('send-to-reseller-shipping');
          document.querySelector('.pay-on-completion input').click();
        }
        const spbError = document.querySelector('.stp-psm-btr-error');
        if (spbError) {spbError.style.display = 'none';}
   });
});

function psOther(){
  document.querySelector('.preferred-shipping-method .psm-items')?.classList.remove('error'); 
}

/* remove Error class */
document.querySelector('.authorise-checkbox input')?.addEventListener('change', function(){
    document.querySelector('.authorise-checkbox').classList.remove('error');
});

document.querySelector('.accept-term-condition input')?.addEventListener('change', function(){
    document.querySelector('.accept-term-condition').classList.remove('error');
});

/* create order js */

document.querySelector('button.create-order-btn').addEventListener('click', async function(){
  
    const pshElement = document.querySelector('.preferred-shipping-method input:checked');
    if(pshElement){
     const psmValue = pshElement.value;
     if(psmValue == 'Other'){
       const psmOtherText = document.querySelector('.preferred-shipping-method .psm-items input')?.value;
       if(psmOtherText == ''){
         document.querySelector('.preferred-shipping-method .psm-items')?.classList.add('error');
         document.querySelector('.closest-lab-wrapper').scrollIntoView({ behavior: 'smooth' });
         return true;
       }
     }
    }else{
      document.querySelector('.preferred-shipping-method').classList.add('error');
      document.querySelector('.closest-lab-wrapper').scrollIntoView({ behavior: 'smooth' });
      return true;
    }

    var paymentMethod = document.querySelector('.stp-payment-box input[name="payment_method"]:checked').value;
    if(pshElement.value == 'Send to my nominated Reseller' && paymentMethod != 'Bill through Reseller'){
      const spbError = document.querySelector('.stp-psm-btr-error');
      if (spbError) {spbError.style.display = 'block';}
      return true;
    }

  
    const accept_tc = document.querySelector('.accept-term-condition input').checked;
    if(!accept_tc){
      document.querySelector('.accept-term-condition').classList.add('error');
      return true;
    }
    
    const srelo = document.querySelector('.selected-reseller-lication').dataset.location;
    if(paymentMethod == 'Bill through Reseller' && !srelo){
      document.querySelector('.reseller-list-popup').classList.add('error');
      document.querySelector('.reseller-list-popup').scrollIntoView({ behavior: 'smooth' });
      return true;
    };

    const accountnumber = document.querySelector('.bill-throght-reseller .btr-account-info input#account-number').value;

    const capricornInput = document.querySelector('.pay-with-capricorn .btr-account-info input#account-number');

    
    this.classList.add('loading');


    const fault_codes = document.querySelector('.additional-details-or-codes textarea')?.value;
    
    const emailId = customer.email;
    const addAttributeArr = [{"name":"Email","value":emailId },{"name":"Payment Method","value":paymentMethod}];

    const jobcompletion = document.querySelector('.job-completion input')?.checked;
    if(jobcompletion){addAttributeArr.push({"name":"job completion","value":'Selected' });}
  
    const authorise = document.querySelector('.authorise-checkbox input')?.checked;
    if(authorise){addAttributeArr.push({"name":"Authorise","value":'Selected' });}
  
    document.querySelectorAll('.lets-get-started .form-item-input > input').forEach(input => {
      const name = input.getAttribute('name'), lgsValue = input.value;
      const valuee = name == 'vin' && lgsValue == '' ? 'VIN is not available' : lgsValue;
      addAttributeArr.push({"name":name.replaceAll('-',' '),"value":valuee});
    });
    document.querySelectorAll('.wnmb-items .form-item.half-width textarea').forEach(textarea => {
      const name = textarea.getAttribute('name'), lgsValue = textarea.value;
      addAttributeArr.push({"name":name.replaceAll('-',' '),"value":lgsValue});
    });
  
    if(paymentMethod == 'Bill through Reseller' && srelo){addAttributeArr.push({"name":"Selected Reseller Location","value":srelo})}
    if(paymentMethod == 'Bill through Reseller' && accountnumber != ''){addAttributeArr.push({"name":"Account Number","value":accountnumber})}
    if(paymentMethod == 'Pay with Capricorn' && capricornInput && capricornInput.value != ''){addAttributeArr.push({"name":"Membership Number","value":capricornInput.value})}

    const send_date = {"email":false,"phone":false};

    let closest_lab = '';
    document.querySelectorAll('.closest-lab-wrapper label.form-item input:checked').forEach(item => {
        if(closest_lab == ''){closest_lab = item.value;}else{closest_lab += ', '+item.value;}
    });
    if(closest_lab != ''){addAttributeArr.push({"name":"Closest Lab","value":closest_lab});}
  
    if(pshElement){
      if(pshElement.value == 'Other'){
         const OtherPSMtext = document.querySelector('.preferred-shipping-method .psm-items input')?.value;
        addAttributeArr.push({"name":"Preferred Shipping Method","value":OtherPSMtext});
      }else{
       addAttributeArr.push({"name":"Preferred Shipping Method","value":pshElement.value});
      }
    }

    console.log('addAttributeArr ',addAttributeArr);
  
    if(pshElement.value == 'Send directly to me'){
      const psmavailable = pshElement.dataset.avl;
      const psmVid = pshElement.dataset.vid;
      if(psmavailable){
        console.log('Available');
        let formData = {items: [{ id: psmVid, quantity: 1, properties: { __postage_fee: true } }]};
        const atcReq = await fetch(window.Shopify.routes.root + "cart/add.js", {method: "POST",headers: { "Content-Type": "application/json" },body: JSON.stringify(formData),});
        console.log('atcReq ',atcReq);
        createOrder(addAttributeArr);
      }else{
        console.log('Not available');
        createOrder(addAttributeArr);
      }
    }else{
      createOrder(addAttributeArr);
    }
});

async function createOrder(addAttributeArr){
  console.log('createOrder function');  
  const cartReq = await fetch('/cart.js');
  const cartJson = await cartReq.json();
  const line_items = cartJson.items.map(line => ({"variant_id":line.id, "quantity": line.quantity,'properties':line.properties}));
  const amount = cartJson.items_subtotal_price;
  
  let mcustomer = customer;
  console.log('attributes ',addAttributeArr);
 
  const createOrderReq = await fetch(`${APP_URL}/api/order`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({"shopUrl": Shopify.shop, "customer": mcustomer,"line_items": line_items,"amount": amount,"attributes":addAttributeArr,'senddate':customer.send_date}),
    });
  const createOrderRes = await createOrderReq.json();
  // console.log('createOrderRes ',createOrderRes);
  // updateSummery(createOrderRes.data);
  // document.querySelector('.steps-main-wrapper').classList.remove('step-second-active');
  // document.querySelector('.steps-main-wrapper').classList.add('step-third-active');
  // window.scrollTo({top: 0,behavior: 'smooth'});
  // window.clearCart();

  const clearCart = await fetch("/cart/clear.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });

  window.location.href = `/pages/order-confirmation?order=${createOrderRes.data.order.name.replace('#','')}`;
}
function updateSetp(step){
  document.querySelector(".stp-form-main").dataset.step = step;
  
  document.querySelectorAll('.booking-step-title-bar .title-block').forEach(item => {
   const bookingStep = parseInt(item.getAttribute('data-step-target'));
   if(bookingStep <= step){
       item.classList.add('active');
   }else{
       item.classList.remove('active');
   }
  });
  
  document.querySelectorAll('ul#booking-steps .js-steptrigger-unp').forEach(item => {
    item.classList.remove('active');
    item.classList.remove('completed');
    const bookingStep = parseInt(item.getAttribute('data-step-target'));
    if(bookingStep < step){
       item.classList.add('completed');
   }else if(bookingStep == step){
      item.classList.add('active');
   }else{
       item.classList.remove('active');
   }
  });
  updateProgress(step);
  document.querySelector(".repair-and-booking-unp-header").scrollIntoView({
    behavior: "smooth"
  });
}

function updateProgress(step) {
    const progressBar = document.getElementById('progress-bar');
    if(step == 1){
      progressBar.style.setProperty('--value', 0);
    }else if(step == 2){
      progressBar.style.setProperty('--value', 50);
    }else if(step == 3){
      progressBar.style.setProperty('--value', 100);
    }
  }

function setNearestReseller(selm, searchquery, index){
  document.querySelector('.ssr-location-grid .ssr-list-wrap.active')?.classList.remove('active');
  selm.closest('.ssr-list-wrap').classList.add('active');
  
  const filejson = window.excel.fileJson;
  const searchArray = filejson.filter(item => item.Title.toLowerCase().includes(searchquery) || item.Postcode == searchquery || item.Address.toLowerCase().includes(searchquery) || item.Phone == searchquery || item.Country.toLowerCase().includes(searchquery) || item.State.toLowerCase().includes(searchquery));
  console.log('location ', searchArray[index]);
  const sloc = searchArray[index];
  document.querySelector('.selected-reseller-lication').innerHTML = `<span class="name">${sloc.Title}</span> - <span class="suburb">${sloc.Suburb}</div>`;
  document.querySelector('.selected-reseller-lication').classList.add('active');
  document.querySelector('.selected-reseller-lication').setAttribute('data-location',`Title:${sloc.Title},Address:${sloc.Address},Suburb:${sloc.Suburb},State:${sloc.State},Country:${sloc.Country},Postcode:${sloc.Postcode},Phone:${sloc.Phone}`);
}

const getCustomerDetails = async (customerId) => {
    const getCustomerReq = await fetch(`${APP_URL}/api/customer`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({"shopUrl": Shopify.shop,"type":"get", "customerId": customerId}),
    });
    const createCustomerRes = await getCustomerReq.json();

    const endpointNote = `${APP_URL}/api/customer/metafield`;
    const getCustomerNoteReq = await fetch(endpointNote, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({"shop": Shopify.shop,"type":"get", "customerId": customerId}),
    });
    const getCustomerNoteRes = await getCustomerNoteReq.json();
    const noteMetafield = getCustomerNoteRes.data.metafields.find((item) => item.namespace === 'custom' && item.key === 'note');
  
    const customer_notes = noteMetafield ? noteMetafield.value.split(", ") : createCustomerRes.data.customer.note.split(", ");
    const formatted_notes = customer_notes.map(item => {
        const [name, value] = item.split(": ", 2);
        return {
            "name": name.replace(/'/g, ""),
            "value": value
        };
    });

  console.log('formatted_notes ',formatted_notes);
    
    const accountNumber = formatted_notes.filter(item => item.name == 'Account Number');
    if(accountNumber.length > 0){document.querySelector('.bill-throght-reseller input#account-number').value = accountNumber[0].value;}

    const membershipNumber = formatted_notes.filter(item => item.name == 'Membership Number');
    if(membershipNumber.length > 0){document.querySelector('.pay-with-capricorn input#account-number').value = membershipNumber[0].value;}

    const paymentMethod = formatted_notes.filter(item => item.name == 'Payment Method');
    if(paymentMethod.length > 0){document.querySelector(`.stp-payment-box input[value="${paymentMethod[0].value}"]`)?.click();}

    const reselletLocation = formatted_notes.filter(item => item.name == 'Selected Reseller Location');
    if(reselletLocation.length > 0){
      const prefredRL = reselletLocation[0].value.split(',');
      const sloc = prefredRL.reduce((acc, item) => {
          const [key, value] = item.split(':');
          acc[key.trim()] = value.trim(); // Add key-value pair to the accumulator object
          return acc;
      }, {});
      console.log('sloc sloc ',sloc);
      document.querySelector('.selected-reseller-lication').innerHTML = `<span class="name">${sloc.Title}</span> - <span class="suburb">${sloc.Suburb}</div>`;
      document.querySelector('.selected-reseller-lication').classList.add('active');
      document.querySelector('.selected-reseller-lication').setAttribute('data-location',`Title:${sloc.Title},Address:${sloc.Address},Suburb:${sloc.Suburb},State:${sloc.State},Country:${sloc.Country},Postcode:${sloc.Postcode},Phone:${sloc.Phone}`);

      const slacHTML = `<div class="ssr-list-wrap">
            <div class="ssr-location">
              <div class="ssr-location-title">Preferred Reseller Location</div>
              <div class="ssr-location-name">${sloc.Title}</div>
              <div class="ssr-location-address">${sloc.Address}<br>${sloc.Suburb +' '+ sloc.State}<br/>PH: ${sloc.Phone}</div>
            </div>
         </div>`;

      document.querySelector('.btr-preselected-reseller-location').innerHTML = slacHTML;
      
    }
  
    return createCustomerRes.data.customer;
}
getCustomerDetails(customer.id);
